import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import constructor from './assets/images/constructor.png';
import mount from './assets/images/mount.png';
import mount2 from './assets/images/mount2.png';
import mount3 from './assets/images/mount3.png';
import unmount from './assets/images/unmount.png';
import render2 from './assets/images/render2.png';
import props from './assets/images/props.png';
import update from './assets/images/update.png';



const ReactLesson14 = () => {
  const [language, changeLanguage] = useState("react");
  const [lineNumbers, toggleLineNumbers] = useState(false);
    const code = (
      'text',
      `
      constructor(props) {
        super(props)
        this.state = {
          //set state here
        }
      }
      `
    );
    const code1 = (
      'text',
      `
      componentwillMount(){
        
      }
      `
    );
    const code2 = (
      'text',
      `
      render(){

      }
      `
    );
    const code3 = (
      'text',
      `
      componentDidMount(){

      }
      `
    );
    const code4 = (
      'text',
      `
      componentwillReceiveprops(){

      }
      `
    );
    const code5 = (
      'text',
      `
      shouldcomponentDidMount(){

      }
      `
    );
    const code6 = (
      'text',
      `
      componentDidUpdate(){

      }
      `
    );
    const code7 = (
      'text',
      `
      componentWillUnmount(){

      }
      `
    );


  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <div className="alert alert-secondary" role="alert">
    <h3><strong>Lifecycle Methods</strong></h3>
      <p>Lifecycle methods are unique methods in React that are called at particular stages of a component's life cycle. With the use of these techniques, programmers can run code when a component is created, changed, or destroyed, for example.</p>
      <p>React's class components used to have several lifecycle methods, but with the introduction of React Hooks, functional components also gained similar functionality through the useEffect hook.</p>
      <p>Before <strong>React 16.8</strong>, lifecycle methods were divided into three main phases:</p>
      <ol class="list-group list-group-numbered mb-4">
        <li class="list-group-item"><strong>Mounting Phase:</strong>
        <ul>
        <li><strong>constructor():</strong> This method is called when an instance of a component is being created.</li>
        <CopyBlock
                        language={"react"}
                        text={code} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />                <li><strong>componentWillMount() (deprecated)</strong>
        Executed just before the component is rendered for the first time.
        </li>
        <CopyBlock
                        language={"react"}
                        text={code1} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />               <li><strong>render()</strong>
        This method is necessary and must be implemented. It returns the JSX (UI) representation of the component.
        </li>
        <CopyBlock
                        language={"react"}
                        text={code2} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />               <li><strong>componentDidMount()</strong>
        Invoked immediately after the component and all its children components have been rendered to the DOM.
        </li>
        <CopyBlock
                        language={"react"}
                        text={code3} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />               </ul>
         </li>
         <li class="list-group-item"><strong>Updating Phase:</strong>
        <ul>
        <li><strong>componentWillReceiveProps() (deprecated):</strong>Invoked when the component is receiving new props.</li>
        <CopyBlock
                        language={"react"}
                        text={code4} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />               <li><strong>shouldComponentUpdate():</strong>Determines if the component should re-render in response to changes in props or state.</li>
<CopyBlock
                        language={"react"}
                        text={code5} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />               <li><strong>componentDidUpdate():</strong>Called immediately after a component re-renders.</li>
<CopyBlock
                        language={"react"}
                        text={code6} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />               </ul>
        </li>
          <li class="list-group-item"><strong>Unmounting Phase:</strong>
        <ul>
        <li><strong>componentWillUnmount():</strong> Invoked immediately before a component is unmounted or destroyed. Used for cleanup operations like removing event listeners or clearing intervals.</li>
        <CopyBlock
                        language={"react"}
                        text={code7} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />               </ul>
        </li>
     </ol>
     <h3><strong>Summary</strong></h3>
     <p>Lifecycle methods are only used in class components. With the introduction of React 16.8, functional components gained state and lifecycle capabilities through React Hooks. We shall look at hooks in the next lesson.</p>
      </div>

      </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default ReactLesson14
  